module.exports = __webpack_public_path__ + "img/c18eb8850b259878c1d0ccbc43d90061.png";